import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { toast } from '../../../lib/toast';
import { updateContact } from '../api/contacts';
import type { ContactFormValues } from '../types';

export function useUpdateContact(id: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ContactFormValues) => {
      if (id == null || id === '') throw new Error('Contact id required');
      return updateContact(id, data);
    },
    onSuccess: () => {
      invalidateListResource(queryClient, 'contacts');
      if (id) queryClient.invalidateQueries({ queryKey: ['contact', id] });
      toast.success('Contact updated');
      onSuccess?.();
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to update contact');
    },
  });
}
